
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcDropdownButton as ObcDropdownButtonElement} from '@oicl/openbridge-webcomponents/dist/components/dropdown-button/dropdown-button.js';
 import {ObcDropdownButtonChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/dropdown-button/dropdown-button.js';
 export type {ObcDropdownButtonChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/dropdown-button/dropdown-button.js';
 

 
 export const ObcDropdownButton = createComponent({
   react: React,
   tagName: 'obc-dropdown-button',
   elementClass: ObcDropdownButtonElement,
   events: {
     
     onDropdownChange: 'dropdown-change' as EventName<ObcDropdownButtonChangeEvent>,
     onChange: 'change' as EventName<ObcDropdownButtonChangeEvent>,
   }
  });
 
 